import React from 'react';
import { CalendarInputCommonProps, CalendarPresetItem } from './types';
import { usePresetList } from './hooks/usePresetList';
import { RadioGroup } from '../../radio';
import { RadioSizeUnion } from '../../radio/types';

export interface PresetRadioGroupProps extends CalendarInputCommonProps {
  size?: RadioSizeUnion;
  presets?: CalendarPresetItem[];
  shouldConfirm?: boolean;
}

export const PresetRadioGroup: React.FC<PresetRadioGroupProps> = ({ size, disabled, ...props }) => {
  const items = usePresetList(props);
  const selectedIndex = items.findIndex((v) => v.selected);
  return (
    <RadioGroup
      size={size}
      variant='box'
      value={selectedIndex}
      disabled={disabled}
      items={items.map((preset, index) => ({
        value: index,
        label: preset.label,
        disabled: preset.disabled,
      }))}
      onChange={(index) => items[index]?.onClick?.()}
    />
  );
};
